import { useState } from "react";
import logo from "../../assets/logo.png";
import { setLink, useLink } from "../../utils/ClickedLink";
import { useNavigate } from "react-router-dom";
import { FaBars, FaTimes } from "react-icons/fa";
import { MdArrowDropDown } from "react-icons/md";


const NavigationComponent = () => {
  const [currentLink, setCurrentLink] = useState(useLink());
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [countryDropdownOpen, setCountryDropdownOpen] = useState(false);
  const navigate = useNavigate();

  const handleLinkClick = (link, path) => {
    setLink(link);
    setCurrentLink(link);
    if (path) navigate(path);
    setMobileMenuOpen(false); // close menu on mobile
    setCountryDropdownOpen(false); // close dropdown
  };

  const handleSendEmail = () => {
    const to = "info@mambahikers.com";
    const subject = encodeURIComponent("Hello from My App");
    const body = encodeURIComponent(
      "Hi there,\n\nI wanted to reach out to you..."
    );

    const gmailUrl = `https://mail.google.com/mail/?view=cm&fs=1&to=${to}`;

    window.open(gmailUrl, "_blank");
  };

  const countries = [
    { label: "Kenya", value: "KE" },
    { label: "Tanzania", value: "TZ" },
    { label: "Uganda", value: "UG" },
    { label: "Rwanda", value: "RW" },
  ];

  return (
    <div className="w-full px-6 md:px-28 py-3 font-semibold">
      <div className="flex justify-between items-center">
        {/* Left nav */}
        <div className="hidden md:flex space-x-8 cursor-pointer relative">
          <div
            onClick={() => handleLinkClick("events", "/events")}
            className={`${currentLink === "events" ? "active-nav-link" : ""}`}
          >
            Events
          </div>
          <div
            onClick={() => handleLinkClick("programmes", "/programmes")}
            className={`${
              currentLink === "programmes" ? "active-nav-link" : ""
            }`}
          >
            Programs
          </div>
          {/* Countries Dropdown */}
          <div
            onMouseEnter={() => setCountryDropdownOpen(true)}
            onMouseLeave={() => setCountryDropdownOpen(false)}
            className="relative"
          >
            <div
              className={`flex items-center ${
                currentLink === "destinations" ? "active-nav-link" : ""
              } `}
            >
              <div>Countries</div>
              <div>
                <MdArrowDropDown size={25} />
              </div>
            </div>
            {countryDropdownOpen && (
              <div className="absolute w-full bg-white shadow-md rounded text-sm py-2 z-[100]">
                {countries.map((country) => (
                  <div
                    key={country}
                    onClick={() =>
                      handleLinkClick(
                        "destinations",
                        `/country/destinations/${country.value.toLowerCase()}`
                      )
                    }
                    className=" px-4 py-2 hover:bg-gray-100 text-xl"
                  >
                    {country.label}
                  </div>
                ))}
              </div>
            )}
          </div>
        </div>

        {/* Logo */}
        <div
          className="h-20 cursor-pointer"
          onClick={() => handleLinkClick("home", "/")}
        >
          <img src={logo} alt="logo" className="h-full" />
        </div>

        {/* Right nav */}
        <div className="hidden md:flex space-x-8 cursor-pointer">
          <div
            onClick={() => handleLinkClick("about-us", "/about-us")}
            className={`${currentLink === "about-us" ? "active-nav-link" : ""}`}
          >
            About Us
          </div>
          <div
          // onClick={() => handleLinkClick("shop-with-us")}
          // className={`${
          //   currentLink === "shop-with-us" ? "active-nav-link" : ""
          // }`}
          >
            <a
              href="https://www.instagram.com/mambahikers_gear_shop?igsh=MThtc28xdGNuaWNqcw== "
              target="_blank"
              rel="noopener noreferrer"
            >
              Shop With Us
            </a>
          </div>
          <div
            onClick={() => handleSendEmail()}
            className={`${
              currentLink === "contact-us" ? "active-nav-link" : ""
            }`}
          >
            Contact Us
          </div>
        </div>

        {/* Mobile Menu Button */}
        <div className="md:hidden text-2xl cursor-pointer">
          {mobileMenuOpen ? (
            <FaTimes onClick={() => setMobileMenuOpen(false)} />
          ) : (
            <FaBars onClick={() => setMobileMenuOpen(true)} />
          )}
        </div>
      </div>

      {/* Mobile Menu Items */}
      {mobileMenuOpen && (
        <div className="flex flex-col space-y-4 mt-4 md:hidden text-center cursor-pointer">
          <div
            onClick={() => handleLinkClick("events", "/events")}
            className={`${currentLink === "events" ? "active-nav-link" : ""}`}
          >
            Events
          </div>
          <div
            onClick={() => handleLinkClick("programmes", "/programmes")}
            className={`${
              currentLink === "programmes" ? "active-nav-link" : ""
            }`}
          >
            Programmes
          </div>
          <div className="flex flex-col">
            <div>Countries</div>
            <div className="flex flex-col mt-1 space-y-1">
              {countries.map((country) => (
                <div
                  key={country}
                  onClick={() =>
                    handleLinkClick(
                      "destinations",
                      `/country/destinations/${country.value.toLowerCase()}`
                    )
                  }
                  className=" px-4 py-2 hover:bg-gray-100 text-xl"
                >
                  {country.label}
                </div>
              ))}
            </div>
          </div>
          <div
            onClick={() => handleLinkClick("about-us", "/about-us")}
            className={`${currentLink === "about-us" ? "active-nav-link" : ""}`}
          >
            About Us
          </div>
          <div
            onClick={() => handleLinkClick("shop-with-us")}
            className={`${
              currentLink === "shop-with-us" ? "active-nav-link" : ""
            }`}
          >
            Shop With Us
          </div>
          <div
            onClick={() => handleLinkClick("contact-us")}
            className={`${
              currentLink === "contact-us" ? "active-nav-link" : ""
            }`}
          >
            Contact Us
          </div>
        </div>
      )}
    </div>
  );
};

export default NavigationComponent;
